export default __webpack_public_path__ + "static/media/feature-cybersecurity-3.5f20339f.png";